exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "body {\r\n  margin: 0;\r\n  padding: 0;\r\n  font-family: 'Roboto', sans-serif;\r\n}\r\n\r\nh1, h2, h3, h4, h5, h6 {\r\n  font-weight: normal;\r\n}\r\n", ""]);

// exports
